import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { AddCall } from 'src/providers/addvCall';

@Component({
  selector: 'app-doclistmod',
  templateUrl: './doclistmod.page.html',
  styleUrls: ['./doclistmod.page.scss'],
})
export class DoclistmodPage implements OnInit {

  FilterDocList = [];
  docID: any;
  docName: any;
  spclty: any;
  

  constructor(
    public modelCtrl: ModalController,
    public addCall: AddCall
  ) { }

  ngOnInit() {}

  ionViewWillEnter() { }

  selectData(data, name, spcl) {
    this.docID = data;
    this.docName = name;
    this.spclty = spcl;
  }

  okCancel(from) {
    this.modelCtrl.dismiss({
      From: from,
      docID: from == 2 ? this.docID : "",
      docName: this.docName,
      spclty: this.spclty,
    });
  }
}
